import { withStyles } from "@material-ui/styles";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import OrganizerCommonHeader from "../OrganizerCommonHeader";
import ApplicationUtil from "../../../../../utils/ApplicationUtil";
import ListPageLoader from "../../../../common/ListPageLoader";
import {
  downloadProgramCSV,
  getProgramEventList,
  getProgramParticipantsList,
} from "../../../../../apis/eventService";
import OrganizerTableList from "../OrganizerTableList";
import Breadcrumbs from "../../../../common/Breadcrumbs";
import { FormControl, NativeSelect, Typography } from "@material-ui/core";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { FilterSVGIcon, IconCalendarBlue } from "../../../../common/SvgIcon";
import DrawerFilter from "../../../../common/DrawerFilter";
import SearchIcon from "@material-ui/icons/Search";
import moment from "moment";
import ArrowDropDownCircleOutlinedIcon from "@material-ui/icons/ArrowDropDownCircleOutlined";
import ApplicationConstants from "../../../../../constants/ApplicationConstants";
import SubmitCancelBtn from "../../../../common/SubmitCancelBtn";

function OrganizerProgramParticipantsList({ classes, history }) {
  const [participantsList, setParticipantsList] = useState(null);
  const [totalParticipants, setTotalParticipants] = useState(null);
  const [listResetLoader, setListResetLoader] = useState(false);
  const [requestParams, setRequestParams] = useState({});
  const [isDrawerOpen, setIsDrawerOpen] = useState(null);
  const [filters, setFilters] = useState({});
  const [dateRangeOptions, setDateRangeOptions] = useState(null);
  const [dateRange, setDateRange] = useState(null);
  const [eventList, setEventList] = useState(null);
  const [programData, setProgramData] = useState([]);
  const [programSessionsList, seProgramSessionsList] = useState(null);

  const [registrationListFilters, setRegistrationListFilters] = useState(
    ApplicationConstants.registrationListFilters
  );

  const [anchorEl, setAnchorEl] = useState(null);
  const selectedProgramDetails = ApplicationUtil.getSupportsProgramDetails();
  let supportDetails = ApplicationUtil.getSupportDetails();

  useEffect(() => {
    initialLoad();
  }, []);

  const initialLoad = (params) => {
    //Dates Range
    let dateRange = [];
    //Last 24 hours --
    let last24Hrs = {
      label: "Last 24 hours",
      value: `${moment().subtract(1, "day").format("YYYY-MM-DD")} ${moment()
        .subtract(1, "day")
        .format("hh:mm:ss")}`,
    };
    //Last 3 days --
    let last3days = {
      label: "Last 3 days",
      value: `${moment().subtract(3, "day").format("YYYY-MM-DD")} ${moment()
        .subtract(3, "day")
        .format("hh:mm:ss")}`,
    };
    //Last 7 days --
    let last7days = {
      label: "Last 7 days",
      value: `${moment().subtract(7, "day").format("YYYY-MM-DD")} ${moment()
        .subtract(7, "day")
        .format("hh:mm:ss")}`,
    };
    //Last month --
    let lastMonth = {
      label: "Last month",
      value: `${moment().subtract(1, "months").format("YYYY-MM-DD")} ${moment()
        .subtract(1, "months")
        .format("hh:mm:ss")}`,
    };
    let customDate = {
      label: "Custom Date",
      value: "Custom Date",
    };
    dateRange.push(last24Hrs, last3days, last7days, lastMonth, customDate);
    if (dateRange.length > 0) {
      setDateRangeOptions(dateRange);
    }

    getList(params || requestParams, 0);
    setFilters({ ...filters, searchSelectValue: "Name", searchValue: "" });
    getProgramEventList({ programId: selectedProgramDetails?.id }).then(
      ({ data }) => {
        let eventDTO = data?.eventDTO;
        let sessions = data?.programSessions;
        setProgramData(data);
        setEventList(eventDTO);
        seProgramSessionsList(sessions);
      }
    );
  };

  async function dateHandleChange(event) {
    setDateRange(event.target.value);
    setListResetLoader(true);
    let params = {
      ...requestParams,
      startDate:
        event.target.value === "Custom Date"
          ? `${moment(filters?.startDate).format(
              "YYYY-MM-DD"
            )} ${moment().format("hh:mm:ss")}`
          : event.target.value,
      endDate:
        event.target.value === "Custom Date"
          ? `${moment(filters?.endDate).format("YYYY-MM-DD")} ${moment().format(
              "hh:mm:ss"
            )}`
          : `${moment().format("YYYY-MM-DD")} ${moment().format("hh:mm:ss")}`,
    };
    await getList(params);
    setFilters({ ...filters, ...params });
    setRequestParams(params);
  }

  async function getList(params, page, isAdd = false) {
    await getProgramParticipantsList({
      ...params,
      programId: selectedProgramDetails?.id,
      pageNumber: page ? page : 0,
      pageCount: 20,
    }).then(({ data }) => {
      if (data?.programParticipant) {
        let list = data?.programParticipant?.filter((item) => !item.testUser);
        if (isAdd) {
          list = participantsList.concat(list);
          setListResetLoader(false);
        }
        setParticipantsList(list || []);
        setTotalParticipants(data?.totalCounts || totalParticipants || 0);
      }
    });
  }
  const searchHandleChange = (event) => {
    setFilters({ ...filters, searchValue: event.target.value || "" });
    setListResetLoader(true);
    if (!event.target.value) {
      let params = {
        ...requestParams,
        name: null,
        bib: null,
        email: null,
        contact: null,
      };
      setRequestParams(params);
      initialLoad(params);
    }
  };

  const selectHandleValue = (event) => {
    setFilters({ ...filters, searchSelectValue: event.target.value });
    setListResetLoader(true);
  };

  const searchHandleClick = async () => {
    let name;
    let bib;
    let email;
    let contact;
    if (filters?.searchSelectValue === "Name") {
      name = filters?.searchValue;
    } else if (filters?.searchSelectValue === "BIB") {
      bib = filters?.searchValue;
    } else if (filters?.searchSelectValue === "Email") {
      email = filters?.searchValue;
    } else if (filters?.searchSelectValue === "Contact") {
      contact = filters?.searchValue;
    }
    let params = {
      ...requestParams,
      name: name,
      bib: bib,
      email: email,
      contact: contact,
    };

    if (
      params.name !== "" ||
      params.email !== "" ||
      params.bib !== "" ||
      params.contact !== ""
    ) {
      await getList(params);
      setListResetLoader(true);
      setRequestParams(params);
    }
  };

  const customStartDate = async (date) => {
    setFilters({ ...filters, startDate: date });
    let params = {
      ...requestParams,
      startDate: `${moment(date).format("YYYY-MM-DD")} ${moment().format(
        "hh:mm:ss"
      )}`,
      endDate: `${moment(filters?.endDate).format(
        "YYYY-MM-DD"
      )} ${moment().format("hh:mm:ss")}`,
    };
    await getList(params);
    setListResetLoader(true);
    setRequestParams(params);
  };
  const customEndDate = async (date) => {
    setFilters({ ...filters, endDate: date });

    let params = {
      ...requestParams,
      startDate: `${moment(filters?.startDate).format(
        "YYYY-MM-DD"
      )} ${moment().format("hh:mm:ss")}`,
      endDate: `${moment(date).format("YYYY-MM-DD")} ${moment().format(
        "hh:mm:ss"
      )}`,
    };
    await getList(params);
    setListResetLoader(true);
    setRequestParams(params);
  };

  const applyFilters = (drawerFilters) => {
    setRegistrationListFilters(drawerFilters);
    let updateFilters = { ...filters };
    for (let i = 0; i < drawerFilters?.length; i++) {
      let ele = drawerFilters[i];

      if (ele.filterType === "Consent") {
        updateFilters.consentPresent =
          ele.selectedValue === "consentProvided"
            ? true
            : ele.selectedValue === "consentNotProvided"
            ? false
            : null;
      }
      if (ele.filterType === "bib") {
        updateFilters.bibGenerated =
          ele.selectedValue === "bibGenerated"
            ? true
            : ele.selectedValue === "bibNotGenerated"
            ? false
            : null;
      }
      if (ele.filterType === "register") {
        updateFilters.onlineRegistration =
          ele.selectedValue === "online"
            ? true
            : ele.selectedValue === "offline"
            ? false
            : null;
      }
    }

    setFilters({ ...updateFilters });
    const params = { ...requestParams, ...updateFilters };
    setRequestParams(params);
    setListResetLoader(true);
    getList(params);
  };

  const eventHandleChange = (event) => {
    setRequestParams({ ...requestParams, eventId: event.target.value });
    setListResetLoader(true);
    getList({ ...requestParams, eventId: event.target.value });
  };
  const sessionHandleChange = (event) => {
    setRequestParams({
      ...requestParams,
      programSessionId: event.target.value,
    });
    setListResetLoader(true);
    getList({ ...requestParams, programSessionId: event.target.value });
  };
  const downloadCSVFile = () => {
    downloadProgramCSV();
  };
  return (
    <>
      <OrganizerCommonHeader
        title={
          `${selectedProgramDetails?.name} Calendar` || "Wellness Calender"
        }
        logo
      />

      <div className={classes.mainContainer}>
        <Breadcrumbs />
        <div className={classes.top}>
          {totalParticipants !== null && (
            <div className={classes.totalRec}>
              <span>
                Participants
                <span style={{ marginLeft: "10px" }}>{totalParticipants}</span>
              </span>
            </div>
          )}

          {totalParticipants !== 0 && totalParticipants !== null && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                <SubmitCancelBtn
                  label="Export"
                  type="submit"
                  onClick={downloadCSVFile}
                />
              </div>
            </div>
          )}
        </div>
        <div className={classes.tableContainer}>
          <div className={classes.searchFilter__row}>
            <div className="search__select">
              <FormControl className={classes.select}>
                <NativeSelect
                  className={classes.selectActivity}
                  value={filters?.searchSelectValue}
                  onChange={selectHandleValue}
                  style={{ width: 100 }}
                >
                  {["Name", "BIB", "Email", "Contact"]?.map((value, index) => (
                    <option value={value}>{value}</option>
                  ))}
                </NativeSelect>
              </FormControl>
              <form
                className="search"
                onSubmit={(e) => {
                  e.preventDefault();
                  searchHandleClick();
                }}
              >
                <input
                  type="search"
                  placeholder="Search..."
                  value={filters?.searchValue}
                  onChange={searchHandleChange}
                />
                <SearchIcon
                  className="search__icon"
                  onClick={searchHandleClick}
                />
              </form>
            </div>
            <div className="filters">
              <FormControl className={classes.formControl}>
                <NativeSelect
                  className={classes.selectActivity}
                  value={filters?.activityType}
                  onChange={eventHandleChange}
                  style={{ width: 130 }}
                >
                  <option value="">All Events</option>
                  {eventList?.map((value, index) => (
                    <option value={value.id}>{value.name}</option>
                  ))}
                </NativeSelect>
              </FormControl>
              <FormControl className={classes.formControl}>
                <NativeSelect
                  className={classes.selectActivity}
                  value={filters?.activityType}
                  onChange={sessionHandleChange}
                  style={{ width: 130 }}
                >
                  <option value="">All Sessions</option>
                  {programSessionsList?.map((value, index) => (
                    <option value={value.id}>{value.name}</option>
                  ))}
                </NativeSelect>
              </FormControl>

              <FormControl className={classes.formControl}>
                <NativeSelect
                  className={classes.selectActivity}
                  value={filters?.dateRange}
                  onChange={dateHandleChange}
                  style={{ width: "auto" }}
                >
                  <option value="">All </option>
                  {dateRangeOptions?.map((value, index) => (
                    <option value={value.value}>{value.label}</option>
                  ))}
                </NativeSelect>
              </FormControl>
              {dateRange === "Custom Date" && (
                <FormControl className={classes.customDate}>
                  <Typography variant="body2" gutterBottom>
                    <span>Start Date</span>
                  </Typography>
                  <KeyboardDatePicker
                    autoOk
                    clearable
                    variant="inline"
                    inputVariant="outlined"
                    format="dd/MM/yyyy"
                    // disableFuture={true}
                    value={filters?.startDate}
                    //error={dobError}
                    style={{
                      width: "150px",
                    }}
                    maxDate={filters?.endDate}
                    InputProps={{
                      classes: {
                        root: classes.datePicker,
                      },
                    }}
                    onChange={(date) => {
                      customStartDate(date);
                    }}
                    keyboardIcon={
                      <IconCalendarBlue className={classes.calendarIconCss} />
                    }
                  />
                </FormControl>
              )}
              {dateRange === "Custom Date" && (
                <FormControl className={classes.customDate}>
                  <Typography variant="body2" gutterBottom>
                    <span>End Date</span>
                  </Typography>
                  <KeyboardDatePicker
                    autoOk
                    clearable
                    variant="inline"
                    inputVariant="outlined"
                    format="dd/MM/yyyy"
                    // disableFuture={true}
                    value={filters?.endDate}
                    //error={dobError}
                    style={{
                      width: "150px",
                    }}
                    InputProps={{
                      classes: {
                        root: classes.datePicker,
                      },
                    }}
                    minDate={filters?.startDate}
                    onChange={(date) => {
                      customEndDate(date);
                    }}
                    keyboardIcon={
                      <IconCalendarBlue className={classes.calendarIconCss} />
                    }
                  />
                </FormControl>
              )}

              <FilterSVGIcon
                onClick={() => setIsDrawerOpen(true)}
                className={classes.filtericonStyling}
              />
              <DrawerFilter
                open={isDrawerOpen}
                onClose={() => setIsDrawerOpen(!isDrawerOpen)}
                onApplyFilter={applyFilters}
                filterData={registrationListFilters}
              />
            </div>
          </div>
          <ListPageLoader
            pageParams={{
              page: 0,
              start: 0,
              limit: 8,
              TotalRecords: totalParticipants,
            }}
            resetLoader={listResetLoader}
            totalLoadedLength={participantsList ? participantsList.length : 20}
            loadNextData={(params) => {
              if (!participantsList.includes(undefined)) {
                getList(requestParams, params.page, true);
              }
            }}
          >
            {participantsList?.length > 0 ? (
              <OrganizerTableList
                isSupport={supportDetails.role === "SUPPORT" ? true : false}
                isProgram={true}
                eventData={{
                  ...selectedProgramDetails,
                  programData: programData,
                }}
                data={participantsList}
                updateParticipantsList={(data, reload) => {
                  if (reload) {
                    getList();
                  }
                }}
                email
                regType
                editReg
              />
            ) : (
              <div className={classes.participantNoResult}>
                {participantsList && participantsList?.length === 0
                  ? "No participants"
                  : participantsList?.length === null
                  ? "Loading participants"
                  : ""}
              </div>
            )}
          </ListPageLoader>
        </div>
      </div>
    </>
  );
}
const styles = (theme) => ({
  mainContainer: {
    marginTop: "58px",
    paddingInline: "20px",
  },
  importContainerCss: {
    margin: "10px",
    padding: "0px 20px",
  },
  mainBody: {
    // marginLeft: 80,
  },
  searchFilter__row: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    marginBottom: "20px",
    "& .search__select": {
      display: "flex",
      alignItems: "flex-end",
    },
    "& .search ": {
      display: "flex",
      alignItems: "center",
      border: "1px solid #bfc0c0",
      borderRadius: "5px",
      height: "35px",
      "& > input": {
        height: "30px",
        outline: "none",
        border: "none",
        fontSize: "16px",
        paddingLeft: "10px",
        borderRight: "2px solid #bfc0c0",
      },
      "& .search__icon": {
        padding: "5px",
        cursor: "pointer",
      },
    },
    "& .filters": {
      display: "flex",
      alignItems: "flex-end",
      fontFamily: "Rubik,sans-serif",
    },
  },
  formControl: {
    margin: theme.spacing(1),
    // minWidth: 120,
    fontFamily: "Rubik, sans-serif",
  },
  select: {
    marginRight: theme.spacing(1),
  },
  selectActivity: {
    // marginTop: theme.spacing(2),
    textAlign: "center",
    color: "#727272",
    fontSize: 18,
  },
  top: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    width: "100%",

    position: "relative",
    bottom: 20,
    marginRight: theme.spacing(8),
  },
  totalRec: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
    fontWeight: 600,
    width: "15%",
    marginRight: "10px",
    background: "rgba( 149, 213, 178, 0.50 )",
    boxShadow: "0 4px 3px 0 rgba( 31, 38, 135, 0.37 )",
    backdropFilter: "blur( 4px )",
    borderRadius: "10px",
    border: "1px solid rgba( 255, 255, 255, 0.18 )",
    // position: "relative",
    // bottom: 20,
  },
  datePicker: {
    height: 38,
    paddingRight: 0,
    fontSize: 15,
    border: "1px solid #08456C",
  },
  calendarIconCss: {
    height: 22,
    width: 22,
  },
  customDate: {
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
  actions: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(2),
  },
  editIcon: {
    color: "#09456C",
    cursor: "pointer",
  },
  labelCss: {
    color: "#727272",
  },
  mandatoryCss: { color: "red" },
  approvalForm: {
    // width: "800px",
    // height: "auto",
    padding: "8px 24px",
  },
  messageType: {
    marginBottom: theme.spacing(2),
  },
  drawerContainer: {
    margin: 20,
    // padding:20,
    width: "300px",
    "& .title": {
      fontSize: 20,
      padding: 10,
      // borderBottom:'1px solid gray',
      // width:'100%'
    },
  },
  drawerListRow: {
    display: "flex",
    alignItems: "center",
    marginTop: 10,
    marginBottom: 10,
  },
  participantNoResult: {
    color: "gray",
    margin: "0 auto",
    fontSize: "25px",
    textAlign: "center",
  },
  filtericonStyling: {
    // width: "20px",
    // height: "25px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "10px",
    color: "#09456C",
    cursor: "pointer",
    margin: theme.spacing(1),
  },
  tableContainer: {
    marginTop: "30px",
  },
  participantNoResult: {
    color: "gray",
    margin: "0 auto",
    fontSize: "25px",
    textAlign: "center",
  },
});
export default compose(
  withStyles(styles, { withTheme: true }),
  withRouter
)(OrganizerProgramParticipantsList);
